import { 
  RouterProvider, 
  createBrowserRouter, 
  redirect,
  Navigate
} from 'react-router-dom'
import NotFound from './pages/error/error404'
import Forbidden from './pages/error/error403'
import InternalServerError from './pages/error/error500'
import Maintenance from './pages/error/maintenance'
import Login from './pages/login'
import Main from './pages/main'
import Nav from './pages/main/nav'
import Coach from './pages/coach'
import Enthusiast from './pages/enthusiast'
import FitnessArticle from './pages/fitnessArticle'
import FitnessVideo from './pages/fitnessVideo'
import FitnessSeries from './pages/fitnessSeries'
import Ingredient from './pages/ingredient'
import Appointment from './pages/appointment'
import PhysicalTest from './pages/physicalTest'
import Questionnaire from './pages/questionnaire'
import User from './pages/user'
import Member from './pages/member'
import Notice from './pages/notice'


const interceptToken = () => {
  const token = localStorage.getItem('token')
  if (token) {
    throw redirect('/')
  }
  return null
}

const interceptNoToken = () => {
  const token = localStorage.getItem('token')
  if (!token) {
    throw redirect('/login')
  }
  return null
}

const router = createBrowserRouter([
  {
    path: '/login',
    element: <Login />,
    loader: () => interceptToken()
  },
  {
    path: '/',
    element: <Main />,
    children: [
      {
        path: '',
        element: <Nav />,
        children: [
          {
            path: '',
            element: <Navigate to="coach" />
          },
          {
            path: 'coach',
            element: <Coach />,
            loader: () => interceptNoToken()
          },
          {
            path: 'enthusiast',
            element: <Enthusiast />,
            loader: () => interceptNoToken()
          },
          {
            path: 'fitnessSeries',
            element: <FitnessSeries />,
            loader: () => interceptNoToken()
          },
          {
            path: 'fitnessVideo',
            element: <FitnessVideo />,
            loader: () => interceptNoToken()
          },
          {
            path: 'fitnessArticle',
            element: <FitnessArticle />,
            loader: () => interceptNoToken()
          },
          {
            path: 'ingredient',
            element: <Ingredient />,
            loader: () => interceptNoToken()
          },
          {
            path: 'appointment',
            element: <Appointment />,
            loader: () => interceptNoToken()
          },
          {
            path: 'physicalTest',
            element: <PhysicalTest />,
            loader: () => interceptNoToken()
          },
          {
            path: 'questionnaire',
            element: <Questionnaire />,
            loader: () => interceptNoToken()
          },
          {
            path: 'user',
            element: <User />,
            loader: () => interceptNoToken()
          },
          {
            path: 'member',
            element: <Member />,
            loader: () => interceptNoToken()
          },
          {
            path: 'notice',
            element: <Notice />,
            loader: () => interceptNoToken()
          },
        ]
      }
    ]
  },
  {
    path: '/403',
    element: <Forbidden />
  },
  {
    path: '/500',
    element: <InternalServerError />
  },
  {
    path: '/maintenance',
    element: <Maintenance />
  },
  {
    path: '/*',
    element: <NotFound />
  }
])

export default function Router() {
  return (
    <RouterProvider router={router} />
  )
}
